import { Box, Container } from "@mui/system";
import { Link as RouterLink } from "react-router-dom";
import React, { useState } from "react";
import {
  Button,
  Typography,
  Modal,
  useMediaQuery,
  Skeleton,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import theme from "../theme/theme";

const ConsultancyModules = ({ loading, consultancy_tabs }) => {
  console.log(consultancy_tabs);
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [selectedModule, setSelectedModule] = useState(null);

  const [open, setOpen] = useState(false);

  const handleOpen = (module) => {
    setSelectedModule(module);
    setOpen(true);
  };

  // const handleClose = () => setOpen(false);

  const handleClose = () => {
    setOpen(false);
    setSelectedModule(null);
  };

  const style = {
    position: "absolute",
    // top: '150px',
    left: "50%",
    transform: "translate(-50%, 50%)",
    bgcolor: "background.paper",
    padding: "50px 40px",
    width: "90%",
    height: "calc(70vh - 150px)",
    overflow: "scroll",
    outline: "none!important",
    maxWidth: "1240px",
  };
  function capitalizeTitle(title) {
    return title.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const replaceAmpersand = (str) => {
    return str.replace(/&amp;/g, "&");
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          padding: "50px 0",
          backgroundColor: "#F0F0F0",
        }}
      >
        <Container maxWidth="xl">
          {loading ? (
            mobile ? (
              <>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height="2.1rem"
                  sx={{
                    maxWidth: "600px",
                    margin: "0 auto 30px auto",
                  }}
                />
                <Skeleton
                  variant="text"
                  width="100%"
                  height="22px"
                  sx={{
                    margin: "auto",
                  }}
                />
                <Skeleton
                  variant="text"
                  width="100%"
                  height="300px"
                  sx={{
                    margin: "0 auto 20px auto",
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    alignItems: "stretch",
                  }}
                >
                  {Array.from({ length: 8 }).map((_, index) => (
                    <Skeleton
                      variant="rectangular"
                      width="calc(100% - 16px)"
                      height="174px"
                      sx={{
                        margin: "0 0 20px 0",
                      }}
                    />
                  ))}
                </Box>
              </>
            ) : (
              <>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height="2.1rem"
                  sx={{
                    maxWidth: "600px",
                    margin: "0 auto 30px auto",
                  }}
                />
                <Skeleton
                  variant="text"
                  width="90%"
                  height="22px"
                  sx={{
                    margin: "auto",
                  }}
                />
                <Skeleton
                  variant="text"
                  width="80%"
                  height="22px"
                  sx={{
                    margin: "0 auto 60px auto",
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    alignItems: "stretch",
                  }}
                >
                  {Array.from({ length: 8 }).map((_, index) => (
                    <Skeleton
                      variant="rectangular"
                      width="calc(25% - 16px)"
                      height="394px"
                      sx={{
                        margin: "0 0 20px 0",
                      }}
                    />
                  ))}
                </Box>
              </>
            )
          ) : (
            <>
              {consultancy_tabs && consultancy_tabs?.tabs_title && (
                <Typography
                  sx={{
                    color: "#265DA5",
                    textAlign: "center",
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    marginBottom: "30px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: consultancy_tabs.tabs_title,
                  }}
                />
              )}

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "stretch",
                  gap: "20px",
                }}
              >
                {
                  Array.isArray(consultancy_tabs?.tabs) &&
                    consultancy_tabs.tabs.map((module) =>
                      module && module.image ? (
                        <Box
                          onClick={() => handleOpen(module)}
                          key={module.id}
                          sx={{
                            width: "calc(25% - 16px)",
                            width: mobile ? "100%" : "calc(25% - 16px)",
                            backgroundColor: "#FFFFFF",
                            marginBottom: "0px",
                            padding: "20px 25px 40px",
                            cursor: "pointer",
                            transition: "box-shadow 0.3s ease-in-out",
                            "&:hover": {
                              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                            },
                            display: mobile ? "flex" : "block",
                            flexDirection: "row-reverse",
                          }}
                        >
                          {/* {!mobile && ( */}
                          <img
                            src={module.image}
                            alt={module.topic}
                            style={{
                              display: "block",
                              width: mobile ? "30%" : "100%",
                              marginBottom: mobile ? "0" : "30px",
                              cursor: "pointer",
                              objectFit: "contain",
                              minHeight: mobile ? "unset" : "225px",
                              maxHeight: mobile ? "unset" : "225px",
                            }}
                          />
                          {/* )} */}
                          <Box
                            sx={{
                              width: mobile ? "70%" : "100%",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#265da5",
                                textAlign: "left",
                                fontSize: "1.2rem",
                                fontWeight: "600",
                                lineHeight: "1.167",
                                marginBottom: "1em",
                                cursor: "pointer",
                              }}
                              dangerouslySetInnerHTML={{
                                // __html: replaceAmpersand(module.topic),
                                __html: capitalizeTitle(
                                  replaceAmpersand(module.topic)
                                ),
                              }}
                            />
                            <Box
                              sx={{
                                textAlign: "left",
                                cursor: "pointer",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: module.resume,
                              }}
                            />
                          </Box>
                        </Box>
                      ) : mobile ? (
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height="174px"
                          sx={{
                            margin: "0 0 20px 0",
                          }}
                        />
                      ) : (
                        <Skeleton
                          variant="rectangular"
                          width="calc(25% - 16px)"
                          height="394px"
                          sx={{
                            margin: "0 0 20px 0",
                          }}
                        />
                      )
                    )
                  // .reverse()
                }
              </Box>
            </>
          )}
        </Container>
      </Box>

      {Array.isArray(consultancy_tabs?.tabs) &&
        consultancy_tabs.tabs.map((module) => (
          <Modal
            open={open && selectedModule === module}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            key={`modal-${module.id}`}
          >
            <Box sx={style}>
              <FontAwesomeIcon
                icon={faTimes}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "30px",
                  cursor: "pointer",
                  fontSize: "2rem",
                  color: "#0D60A8",
                }}
                onClick={handleClose}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: mobile ? 0 : "60px",
                  flexDirection: mobile ? "column-reverse" : "row",
                }}
              >
                <Box
                  sx={{
                    width: mobile ? "100%" : "63%",
                  }}
                >
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{
                      fontSize: "1.8rem",
                      fontWeight: "800",
                      color: "#0D60A8",
                    }}
                    dangerouslySetInnerHTML={{
                      // __html: replaceAmpersand(module.topic),
                      __html: capitalizeTitle(replaceAmpersand(module.topic)),
                    }}
                  />
                  <Typography
                    id="modal-modal-description"
                    sx={{ mt: 2, marginBottom: "20px" }}
                    dangerouslySetInnerHTML={{
                      __html: module.content,
                    }}
                  />
                  <Button
                    component={RouterLink}
                    to={module.link_url}
                    sx={{
                      p: "0.5rem 2rem",
                      borderRadius: "2rem",
                      color: "#fff",
                      fontSize: "1rem",
                      backgroundColor: "#265da5",
                    }}
                  >
                    {module.link_text}
                  </Button>
                </Box>
                <img
                  src={module.image}
                  alt={module.topic}
                  style={{
                    // width: mobile ? '100%' : '32%',
                    width: mobile ? "100%" : "42%",
                    height: "auto",
                    objectFit: "contain",
                    marginBottom: mobile ? "16px" : 0,
                  }}
                />
              </Box>
            </Box>
          </Modal>
        ))}
    </>
  );
};

export default ConsultancyModules;
